import { atom } from "recoil";

export const addStateDistributionChannel = atom({
  key: "addStateDistributionChannel ",
  default: false,
});
export const editStateDistributionChannel = atom({
  key: "editStateDistributionChannel",
  default: false,
});
export const selectedDistributionChannel = atom({
  key: "selectedDistributionChannel",
  default: [],
});

export const selectedRowsStateDistributionChannel = atom({
  key: "selectedRowsStateDistributionChannel",
  default: [],
});

export const setFilterTextDistributionChannel = atom({
  key: "setFilterTextDistributionChannel",
  default: "",
});
